import { getCoreState } from './core-state';
import { ChildReducerName } from '../constants/other';
export const getLoadingState = (state) => getCoreState(state)[ChildReducerName.loading];
export const isLoading = (state, requestId) => getLoadingState(state)[requestId];
